module.exports = __webpack_public_path__ + "static/adonis (3)-7c06034d632733d95da8db9d3e0eaf1b.jpg";